export const config = {
    auth0ClientId: "066BSdDlX00RrLG253BYFtIpllwV5prS",
    auth0Domain: "https://dev-1taiqb4v.us.auth0.com"
};